




































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import _pick from 'lodash/pick';
import _values from 'lodash/values';
import _cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import { RedactModule } from '@/store/modules/redact';
import { getPageByPath, _transformKeys } from '@/utils';
import {
  getListPageData,
  postListPageData,
  deleteListPageData,
  patchListPageData,
  sortListPageData,
  exportReadDataByDate,
  setPvVisible,
} from '@/api/redact';

import menuApi from '@/api/menu';

import { Item, ItemKey, PageKey, PreviewItem } from '@/types';
import { IAttachmentComplete } from '@/types/pageData';
// import suneditor from 'suneditor';
// import plugins from 'suneditor/src/plugins';
// import lang from 'suneditor/src/lang';
// import { ButtonListItem } from 'suneditor/src/options';
// import SunEditor from 'suneditor/src/lib/core';
import {
  plugin_dialog_component_fileManager,
  plugin_dialog_component_videoManager,
} from '@/utils/editorPlugin';
import { UserModule } from '@/store/modules/user';
import { Role } from '@/api/types';
import { IMenu } from '@/types/menu';
import FilterForm from './FilterForm.vue';
import {
  postActivity,
  getActivityByItemId,
  putActivity,
  deleteActivity,
} from '../../../api/active';
import _omit from 'lodash/omit';
import { setHomeVisible } from '../../../api/redact';
import MoveToTemplateDialog from './MoveToTemplateDialog.vue';
import ExportDataDialog from './ExportDataDialog.vue';
import ProfileFormItem from './ProfileFormItem.vue';

const keyOrder = ['cover', 'title', 'introduction', 'externalLink', 'detail', 'publish_time'];

const defaultActivityData = {
  _id: '',
  enabled: false,
  startTime: '' as Date | string,
  endTime: '' as Date | string,
  place: '',
  relatedPeople: '',
  date: '',
  endDate: '',
};

const defaultExData = {
  pvVisible: false,
};

const DEFAULT_ACTIVE_ENABLED = false;

@Component({
  components: { FilterForm, MoveToTemplateDialog, ExportDataDialog, ProfileFormItem },
})
export default class Layout extends Vue {
  VUE_APP_BASE_API = process.env.VUE_APP_BASE_API;
  private dialogVisible = false;
  private moveTemplateDialogVisible = false;
  private exportDataDialogVisible = false;
  private lockExport = false;
  private editing = false;
  isFilterFormUnfold = false;
  private editingId = '';
  private newData: PageKey[] = [];
  // el-upload 只识别 name 字段, IAttachmentComplete 中该字段需保留
  private attachments: IAttachmentComplete[] = [];
  private dialogData: PageKey[] = [];
  collapseItem: string[] = [];
  private pageConfig: IMenu = {
    pattern: 'init',
    name: 'init',
    type: 'vain',
    keys: [],
    subs: [],
  };
  private originData: Item[] = [];
  private editingItem: Item | {} = {};
  private listData: any[] = [];
  private count = 0;
  private currentPage = 1;
  private loading = false;
  private configReady = false;
  // editors: Record<string, SunEditor> = {};
  moveFrom: string = '';
  moveTo: string = '';
  isFilterResultView: boolean = false;
  dirty: boolean = false; //表单是否有修改
  activity = { ...defaultActivityData };
  exData = { ...defaultExData };

  get username() {
    return UserModule.username;
  }

  get isTeacher() {
    return !!UserModule.jaccountId && UserModule.jaccountType === 'teacher';
  }

  get isSuperadmin() {
    return UserModule.isSuperadmin;
  }

  isTeacherSelf(dialogData: PageKey[]) {
    if (this.filterFormType === 'teacher' && !!UserModule.jaccountId) {
      const nameKey = dialogData.find((i) => i.pattern === 'name');
      if (nameKey && UserModule.username === nameKey.value) {
        return true;
      }
    }
    return false;
  }
  get dialogTitle() {
    return this.editing ? '编辑数据' : '添加数据';
  }

  get pages() {
    return RedactModule.pages;
  }

  get disabledSubmit() {
    return this.attachments.some((i) => i.status !== 'success');
  }

  get showActivitySwitch() {
    return (
      this.pageConfig.templatePattern === 'article1' ||
      this.pageConfig.templatePattern === 'article2'
    );
  }

  // 是否显示筛选项
  get isFilterEnable() {
    return (
      (this.pageConfig.templatePattern === 'character1' ||
        this.pageConfig.templatePattern === 'character2' ||
        this.pageConfig.templatePattern === 'article1' ||
        this.pageConfig.templatePattern === 'article2') &&
      !(this.filterFormType === 'teacher' && this.isTeacher)
    );
  }

  // 是否 默认为倒序页面
  // [图文模板, 文字模板]默认为倒序
  get isDesc() {
    return ['article1', 'article2'].includes(this.pageConfig.templatePattern || '');
  }

  // 获取筛选表格类型: 教师/文章
  get filterFormType() {
    const templatePattern = this.pageConfig.templatePattern;
    if (templatePattern === 'character1' || templatePattern === 'character2') {
      return 'teacher';
    }
    if (templatePattern === 'article1' || templatePattern === 'article2') {
      return 'article';
    }
    return '';
  }

  get showExportBtn() {
    return ['article1', 'article2', 'article3'].includes(this.pageConfig.templatePattern || '');
  }

  get filterFormTitleList() {
    const { templatePattern } = this.pageConfig;
    if (templatePattern === 'character1') {
      return ['院长', '副院长', '党委书记', '党委副书记', '常务副院长', '学工负责人'];
    }
    if (templatePattern === 'character2') {
      return [
        '讲席教授',
        '特聘教授',
        '长聘教授',
        '首席研究员',
        '长聘副教授',
        '长聘教轨副教授',
        '长聘教轨助理教授',
        '副研究员',
        '助理研究员',
        '助教',
        '教授',
        '副教授',
        '讲师',
        '研究员',
        '高级工程师',
        '助理工程师',
        '研究员（工程技术）',
        '研究员（实验技术）',
        '高级实验师',
        '实验师',
        '助理实验师',
        '博士后',
      ];
    }
    return [];
  }

  get filterFormMajorList() {
    return _get(
      this.pageConfig.keys.find((i) => i.pattern === 'major'),
      'choices',
      [],
    );
  }

  // 初始化
  @Watch('pages')
  async onPagesChange() {
    this.init();
  }

  // 当前页码变了后重新拉取数据
  @Watch('currentPage')
  async onCurrentPageChange() {
    await this.fetchData(undefined);
  }

  handleChange(e: { key: string; value: string } | undefined) {
    if (e && e.key) {
      const item = this.dialogData.find((i) => i.pattern === e.key);
      if (item) {
        item.value = e.value;
      }
    }
    this.$forceUpdate();
    this.dirty = true;
  }

  close() {
    this.dialogVisible = false;
    this.dirty = false;
    this.editingId = '';
    this.activity = { ...defaultActivityData };
    this.exData = { ...defaultExData };
  }

  onDialogCancel() {
    if (this.dirty) {
      this.$confirm('即将离开页面，请确保填写内容均已保存', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(this.close)
        .catch(() => {});
    } else {
      this.close();
    }
  }

  moveToOtherTemplate(item: IMenu) {
    this.moveTemplateDialogVisible = false;
    if (this.pageConfig.path && item.path && Object.keys(this.editingItem).length) {
      menuApi
        .moveItemToPage({
          pathFrom: this.pageConfig.path,
          pathTo: item.path,
          itemId: (this.editingItem as Item)._id,
        })
        .then(() => {
          this.$message.success('移动成功');
          location.reload();
        });
    }
  }

  beforeDialogClose(done) {
    if (this.dirty) {
      this.$confirm('即将离开页面，请确保填写内容均已保存', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.dirty = false;
          done();
          this.close();
        })
        .catch(() => {});
    } else {
      this.dirty = false;
      this.close();
      done();
    }
  }

  async fetchData(conditions: object | undefined) {
    try {
      this.loading = true;
      const { data } = await getListPageData(
        `/crud${this.pageConfig.path}`,
        conditions,
        10,
        (this.currentPage - 1) * 10,
      );
      this.loading = false;
      this.originData = data.items;
      this.count = data.count;
      let listData = this.originData.map((d) => _transformKeys(d)) as PreviewItem[];
      if (this.isTeacher && this.filterFormType === 'teacher') {
        listData = listData.filter((i) => i.name === UserModule.username);
      }
      this.listData = listData;
    } catch (error) {
      this.$message.error(error.message);
    }
  }

  toggleFilterFormShow() {
    if (this.collapseItem.includes('filterForm')) {
      this.collapseItem = this.collapseItem.filter((i) => i !== 'filterForm');
    } else {
      this.collapseItem.push('filterForm');
    }
  }

  onHomeVisibleChange(index: number, value: boolean) {
    let locked = false;
    const item = this.originData[index];
    if (locked) return;
    locked = true;
    try {
      setHomeVisible({ value, id: item._id, path: item.pagePattern }).then(() => {
        Vue.set(this.originData[index], `homeVisible`, value);
        this.$message.success('编辑成功');
      });
    } catch (error) {
      this.$message.error(error.message);
    } finally {
      locked = false;
    }
  }

  async handleEditorInput(event, key) {
    key.value = event.html;
  }

  handleAvatarSuccess(index) {
    return (res, file) => {
      this.dialogData[index].value = res.url;
      this.$forceUpdate();
    };
  }

  beforeUpload(file: File) {
    if (file.size > 200 * 1024 * 1024) {
      this.$message.error('所选文件大小超过最大限制');
      return false;
    }
  }

  onAttachmentsUploadChange(file, filelist) {
    this.dirty = true;
    this.attachments = filelist;
  }

  onAttachmentRemove(attachment: IAttachmentComplete) {
    if (attachment.isOriginal) {
      this.attachments = this.attachments.filter((i) => i.url !== attachment.url);
    } else {
      this.attachments = this.attachments.filter((i) => i.uid !== attachment.uid);
    }
  }

  formatDate(date: string) {
    return date && moment(date).format('YYYY-MM-DD HH:mm');
  }

  formatExternalLink(link: string | undefined) {
    if (link) {
      return '是';
    }
    return '否';
  }

  checkDateInput() {
    const publishTimeItem = this.dialogData.find((i) => i.pattern === 'publish_time');
    if (
      this.activity.enabled &&
      !this.activity.date &&
      ((publishTimeItem && !publishTimeItem.value) || !publishTimeItem)
    ) {
      return false;
    }
    return true;
  }

  async submit() {
    if (!this.checkDateInput()) {
      this.$message.error('显示在日历时, 必须选择日期');
      return;
    }

    // @ts-ignore
    const editors = (this.$refs.profileFormItem as Vue).editors;

    const submitData = this.dialogData.map((key) => {
      if (key.type !== 'html') {
        // 如果发布时间未被选择, 则将发布时间设定为当前时间
        if (key.pattern === 'publish_time' && (key.value === '' || key.value === undefined)) {
          return {
            pattern: key.pattern,
            value: moment().format(),
          };
        }
        return {
          pattern: key.pattern,
          value: key.value || '',
        };
      }
      return {
        pattern: key.pattern,
        value: editors[key.pattern].getContents(false),
      };
    });
    const attachments = this.attachments
      .filter((i) => i.status === 'success')
      .map((i) => {
        if (i.isOriginal) return _pick(i, ['filename', 'url', '_id']);
        return { filename: i.name, url: i.response!.url };
      });
    try {
      let added: { item: ItemKey } | undefined;
      if (!this.editing) {
        // 添加数据
        const rs = await postListPageData(`/crud${this.pageConfig.path}`, {
          keys: submitData,
          top: this.isDesc,
          attachments,
        });
        this.$message.success('添加成功');
        added = rs.data;
      } else {
        // 编辑数据
        await patchListPageData(`/crud${this.pageConfig.path}`, this.editingId, {
          keys: submitData,
          attachments,
        });
        this.$message.success('编辑成功');
      }
      const id = this.editingId || added?.item._id;

      // 是否添加到日历
      if (this.activity.enabled) {
        const publishTimeItem = this.dialogData.find((i) => i.pattern === 'publish_time');
        const titleItem = this.dialogData.find((i) => i.pattern === 'title');
        const time =
          !!this.activity.startTime && !!this.activity.endTime
            ? `${this.convertTime(this.activity.startTime)} - ${this.convertTime(
                this.activity.endTime,
              )}`
            : undefined;
        if (this.activity._id) {
          await putActivity(this.activity._id, {
            ..._pick(this.activity, ['relatedPeople', 'place']),
            date: this.activity.date || publishTimeItem?.value,
            endDate: this.activity.endDate,
            title: titleItem?.value ?? '',
            time,
            itemId: this.editingId,
            pagePattern: this.pageConfig.path,
          });
        } else {
          await postActivity({
            ..._pick(this.activity, ['relatedPeople', 'place']),
            date: this.activity.date || publishTimeItem?.value,
            endDate: this.activity.endDate,
            title: titleItem?.value ?? '',
            time,
            itemId: id,
            pagePattern: this.pageConfig.path,
          });
        }
      } else {
        if (this.activity._id) {
          await deleteActivity(this.activity._id);
        }
      }

      // pvVisible 处理
      if (this.pageConfig.path && id) {
        await setPvVisible({
          path: this.pageConfig.path,
          pvVisible: this.exData.pvVisible ?? false,
          id,
        });
      }

      this.dialogVisible = false;
      this.editingId = '';
      this.activity = { ...defaultActivityData };
      location.reload();
    } catch (error) {
      this.$message.error(error.message);
    }
  }

  convertTime(timeStr) {
    const time = moment(timeStr, 'h:mm A').format('h:mma');
    return time;
  }

  onFilterSubmit(formValue) {
    if (_values(formValue).some((i) => i !== '' && i !== undefined)) {
      this.isFilterResultView = true;
    } else {
      this.isFilterResultView = false;
    }
    this.fetchData({
      ...formValue,
      fuzzy: this.filterFormType === 'teacher' ? undefined : true,
    });
  }

  sortDialogData(dialogData) {
    return keyOrder
      .map((key) => dialogData.find((i) => i.pattern === key))
      .filter(Boolean)
      .concat(dialogData.filter((i) => !keyOrder.includes(i.pattern))) as ItemKey[];
  }

  async create() {
    this.editing = false;
    this.editingId = '';
    this.dialogVisible = true;
    this.dialogData = this.sortDialogData(_cloneDeep(this.newData));

    // 生成文本编辑器
    // this.dialogData
    //   .filter((i) => i.type === 'html')
    //   .forEach((i, index) => {
    //     if (!this.editors[i.pattern]) {
    //       setTimeout(() => {
    //         this.initEditor(i.pattern);
    //         this.editors[i.pattern].setContents('');
    //       });
    //     } else {
    //       this.editors[i.pattern].setContents('');
    //     }
    //   });
    if (this.filterFormType === 'article') {
      this.activity.enabled = DEFAULT_ACTIVE_ENABLED;
    }
    this.$forceUpdate();
  }

  edit(index) {
    this.editing = true;
    this.editingId = this.originData[index]._id;
    this.dialogVisible = true;
    // 可编辑项排序
    this.dialogData = this.sortDialogData(_cloneDeep(this.originData[index].keys));
    this.editingItem = { ...this.originData[index] };
    this.exData = { ..._pick(this.originData[index], ['pvVisible']) };
    // 获取活动列表
    getActivityByItemId(this.editingId).then((rs) => {
      if (Object.keys(rs).length) {
        const time = rs.time;
        this.activity = {
          enabled: true,
          startTime: time && moment(time.split('-')[0].trim(), 'hh:mma').toDate(),
          endTime: time && moment(time.split('-')[1].trim(), 'hh:mma').toDate(),
          ..._pick(rs, ['_id', 'place', 'date', 'endDate']),
          relatedPeople: rs.relatedPeople,
        };
      } else {
        Vue.set(this.activity, 'enabled', false);
      }
    });
    this.attachments = this.originData[index].attachments.map((i) => ({
      url: i.url,
      name: i.filename,
      filename: i.filename,
      status: 'success',
      isOriginal: true,
    }));
  }

  async remove(index) {
    try {
      await this.$confirm('此操作将永久删除该数据，是否继续', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });
      const activity = await getActivityByItemId(this.originData[index]._id);

      if (activity._id) {
        await deleteActivity(activity._id);
      }
      await deleteListPageData(`/crud${this.pageConfig.path}`, this.originData[index]._id);
      this.$message.success('删除成功');
      location.reload();
    } catch (error) {
      if (error !== 'cancel') {
        this.$message.error(error.message);
      }
    }
  }

  get auths() {
    return UserModule.auths;
  }

  async init() {
    this.configReady = false;
    if (this.pages && this.pages.length > 0) {
      this.pageConfig = getPageByPath(this.pages, String(this.$route.query.path));
      const parentPattern = this.pageConfig.path?.split('/')[1];
      // 用户不是超级管理员且无该页面权限, 则跳转出该页面
      if (!parentPattern || (!UserModule.isSuperadmin && !this.auths.includes(parentPattern))) {
        this.$router.replace('/redact/tree');
        return;
      }
      this.newData = this.pageConfig.keys;
      this.newData.forEach((key) => (key.value = ''));
      if (this.isTeacher) {
        this.fetchData({ name: UserModule.username });
      } else {
        this.fetchData(undefined);
      }
    }
    this.configReady = true;
  }

  async mounted() {
    this.init();
  }

  async updateView() {
    this.$forceUpdate();
  }

  async sort() {
    if (!this.moveFrom || !this.moveTo) {
      this.$message.warning('起始位置与结束位置必填');
      return;
    } else if (this.moveFrom === '0' || this.moveTo === '0') {
      this.$message.warning('起始或结束位置不能为 0');
      return;
    } else if (
      Number(this.moveFrom) < (this.currentPage - 1) * 10 + 1 ||
      Number(this.moveFrom) > this.currentPage * 10 + 1
    ) {
      this.$message.warning(`起始位置须在当页序号范围内`);
      return;
    } else if (Number(this.moveFrom) > this.count || Number(this.moveTo) > this.count) {
      this.$message.warning(`起始或结束位置不能大于 ${this.count}`);
      return;
    }

    try {
      await sortListPageData(
        `/crud${this.pageConfig.path}`,
        this.originData[Number(this.moveFrom) - 1 - (this.currentPage - 1) * 10]._id,
        {
          rank:
            Number(this.moveTo) > Number(this.moveFrom)
              ? Number(this.moveTo)
              : Number(this.moveTo) - 1,
        },
      );
      this.$message.success('排序成功');
      setTimeout(() => {
        location.reload();
      }, 500);
    } catch (error) {
      this.$message.error(error.message);
    }
  }

  //输入框仅允许输入 number
  numberOnly(e) {
    const a = e.key.replace(/[^\d]/g, '');
    if (!a && e.keyCode !== 8) {
      e.preventDefault();
    }
  }

  openExportDataDialog() {
    this.exportDataDialogVisible = true;
  }

  exportData({ startDate, endDate }: { startDate: Date; endDate: Date }) {
    if (!this.pageConfig.path) return;
    if (this.lockExport) return;
    this.lockExport = true;
    exportReadDataByDate({
      startDate: moment(startDate).format('YYYY-MM-DD'),
      endDate: moment(endDate).format('YYYY-MM-DD'),
      path: this.pageConfig.path,
    })
      .then((res) => {
        let blob = new Blob([res.data]);
        const fileName = `PVData_${moment(startDate).format('YYYY-MM-DD')}_${moment(endDate).format(
          'YYYY-MM-DD',
        )}.xlsx`;
        if ((window.navigator as any).msSaveOrOpenBlob) {
          (navigator as any).msSaveBlob(blob, fileName);
        } else {
          const eLink = document.createElement('a');
          eLink.style.display = 'none';
          eLink.href = URL.createObjectURL(blob);
          if (fileName) eLink.download = fileName;
          document.body.appendChild(eLink);
          eLink.click();
          setTimeout(() => {
            URL.revokeObjectURL(eLink.href);
            document.body.removeChild(eLink);
          }, 2000);
        }
      })
      .finally(() => {
        this.lockExport = false;
      });
  }
}
